import React, { useEffect, useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";

import { accountService } from "../../../../AccountService";
import { IAccountAdjustDetail, IAccountAdjustFields, IAccountAdjustSearch, IAccountAdjustSearchParam } from "../../../../AccountTypes";
import { useDetailModel } from "../detailModel";
import { useGlobalModel } from "@/model/globalModel";
import { ISearchPage } from "@/types/ScmTypes";
import { transPgToPagination } from "@/utils/utils";
import { globalPrompt } from "@/components/message";
import { message } from "antd";

export const useAdjustModel = createModel(function () {
    const initSearchParam: IAccountAdjustSearchParam = {};
    const initDataSource: IAccountAdjustDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const { customerCode } = useDetailModel();
    const { user: { shopCode,username } } = useGlobalModel();
    
    //查询条件
    const [searchParam, setSearchParam] = useState<IAccountAdjustSearchParam>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IAccountAdjustDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IAccountAdjustDetail>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [reload, setReload] = useState(false);
    const [adjustDrawerVisible, setAdjustDrawerVisible] = useState(false);
    const [loading, setLoading] = useState(false)

    const onSearch = () => {
        loadData({ pageNum: 1 }).then()
    }
    const onReset = () => {
        resetSearchParam()
    }


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IAccountAdjustFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IAccountAdjustSearchParam = searchParam) => {
        try {
            setLoading(true)
            const searchParams: IAccountAdjustSearch = {
                ...searchValue,
                statusList: searchValue.statusList as any ?? "1,2,8",
                partnerCode: customerCode,
                shopCode,
                page: {
                    pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                    pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
                }
            }
            let { retData } = await accountService.adjustPage(searchParams);
            const { records, ...pg } = retData;
            setPgCfg(transPgToPagination(pg));
            setDataSource(records);
            clearSelectData();
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }

    }
    const onRevocation = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            if (selectedData?.status !== 1) return message.error("该条记录不可撤回!");
            globalPrompt("modal", {
                title: "警告", type: "warning", text: "是否确认撤回", onOk: async () => {
                    let insertRet = await accountService.adjustApproval({
                        code: selectedData.code,
                        status: 3,
                        approver: username,
                    });
                    if (insertRet.success) {
                        message.success("撤回成功!");
                    } else {
                        message.success("撤回失败!" + insertRet.retMsg);
                    }
                    loadData()
                },
                cancelShow: true,
            })
        } else {
            message.error("请选择待审核记录!");
        }

    }

    return {
        /***field***/
        searchParam,
        reload,
        dataSource,
        selectedRowKeys,
        pgCfg,
        selectedData,
        adjustDrawerVisible,
        /***method***/
        setDataSource,
        setReload,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setAdjustDrawerVisible,
        onSearch,
        onReset,
        setSelectedData,
        onRevocation,
        loading, setLoading
    }
});
